"use strict";
var transformEntities = function(entities, relations, relationSchema) {
  if (typeof entities == 'undefined') {
    return;
  }
  var entityMap = {};
  for (var index = 0; index < entities.length; index++) {
    var entity = entities[index];
    entityMap[entity.id] = entity;
    entity._guidata = entity._guidata || {};
    entity._guidata.parent = null;
    entity._guidata.children = [];
    entity._guidata.crossRelations = [];
    entity._guidata.level = null;
    entity._guidata.relation_label = null;
    entity._guidata.index = index;
    entity._guidata.relations = [];
  }
  var getHierarchy = function(relation) {
    var sourceEntity = entityMap[relation.source];
    var destEntity = entityMap[relation.dest];
    if (!sourceEntity || !destEntity)
      return null;
    var rel = relationSchema[sourceEntity.typ];
    if (!rel)
      return null;
    for (var i = 0; i < rel.length; ++i) {
      if (rel[i].target.indexOf(destEntity.typ) != -1 && rel[i].typ == relation.typ)
        return rel[i].hierarchy;
    }
    return "child";
  };
  var parentMap = {};
  for (var index = 0; index < relations.length; index++) {
    var relation = relations[index];
    var parent = entityMap[relation.source];
    var child = entityMap[relation.dest];
    if (getHierarchy(relation) != 'child') {
      parent._guidata.crossRelations.push(child.id);
      child._guidata.crossRelations.push(parent.id);
    } else {
      entityMap[relation.dest]._guidata.relation_label = relation.typ;
      child._guidata.parent = parent;
      parent._guidata.children.push(child);
    }
  }
  for (var index = 0; index < entities.length; index++) {
    var entity = entities[index];
    entity._guidata.children.sort(function(e1, e2) {
      return e1._guidata.index - e2._guidata.index;
    });
  }
  var getLevel = function(entity) {
    if (entity._guidata.level == null) {
      if (entity._guidata.parent == null)
        entity._guidata.level = 0;
      else {
        entity._guidata.level = getLevel(entity._guidata.parent) + 1;
      }
    }
    return entity._guidata.level;
  };
  var toplevelEntities = [];
  for (var index = 0; index < entities.length; ++index) {
    getLevel(entities[index]);
    if (entities[index]._guidata.level == 0)
      toplevelEntities.push(entities[index]);
  }
  var sortIndex = 0;
  var setSortIndex = function(entity) {
    entity._guidata.sortIndex = sortIndex++;
    for (var index = 0; index < entity._guidata.children.length; ++index) {
      setSortIndex(entity._guidata.children[index]);
    }
  };
  for (var index = 0; index < toplevelEntities.length; ++index) {
    setSortIndex(toplevelEntities[index]);
  }
  entities.sort(function(e1, e2) {
    return e1._guidata.sortIndex - e2._guidata.sortIndex;
  });
};
var updateRelations = function(entities, relations) {
  var entityMap = {};
  for (var index = 0; index < entities.length; index++) {
    var entity = entities[index];
    entityMap[entity.id] = entity;
  }
  var cleanedRelations = [];
  for (var index = 0; index < relations.length; index++) {
    var relation = relations[index];
    if (typeof entityMap[relation.dest] != 'undefined') {
      cleanedRelations.push(relation);
    }
  }
  return cleanedRelations;
};
module.exports = {
  transformEntities: transformEntities,
  updateRelations: updateRelations
};
